import { Component, Injectable, Input, NgZone, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TypeaheadBaseComponent } from '@bhtp-client-web/component';
import { AgentCodeTypeaheadService } from '../../services';
import { ApiAgentInformation } from '../../models';

const AGENT_TYPEAHEAD_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TypeaheadAgentCodeSearchComponent),
    multi: true
};

@Component({
    selector: 'typeahead-agent-code-search',
    providers: [AGENT_TYPEAHEAD_VALUE_ACCESSOR],
    template: require('./typeahead-agent-search.component.html')
})
@Injectable()
export class TypeaheadAgentCodeSearchComponent extends TypeaheadBaseComponent<ApiAgentInformation> {
    @Input() searchType: string;

    public itemDisplayPropertyName: string = 'agentCode';
    public typeAheadWaitInMs: number = 175;
    public placeHolder: string = 'Agent ID';

    constructor(public typeaheadService: AgentCodeTypeaheadService, zone: NgZone) {
        super(typeaheadService, zone);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/components/agents/typeahead-agent-code-search.component.ts